"use client";

import { usePathname } from "next/navigation";
import DealFilmKop from "@/components/deals/DealFilmKop";
import { isVoucherFilmKopRoute } from "@/lib/filmkop-route";
import { stripLocalePrefix } from "@/lib/site-routing";
import MarketingLoading from "../../loading";

export default function VoucherLoading() {
  // loading.js krijgt geen params. usePathname is ook bij de eerste
  // serverrender beschikbaar; gebruik dezelfde routepoort als Navbar.
  const pathname = usePathname();
  if (!isVoucherFilmKopRoute(stripLocalePrefix(pathname || "/"))) {
    return <MarketingLoading />;
  }

  return (
    <>
      {/* Zonder foto/film: dezelfde donkere ondergrond en maten als de deal. */}
      <DealFilmKop />
      <div className="max-w-[1320px] mx-auto px-4 py-8">
        {/* Bestaand marketingskelet, zonder GeenFilmKop-melding. */}
        <div className="w-full h-[300px] bg-gray-200 rounded-lg animate-pulse mb-8" />
        <div className="space-y-4">
          <div className="h-8 bg-gray-200 rounded w-1/3 animate-pulse" />
          <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="bg-white rounded-lg overflow-hidden border border-gray-200"
              >
                <div className="h-48 bg-gray-200 animate-pulse" />
                <div className="p-4 space-y-3">
                  <div className="h-5 bg-gray-200 rounded w-3/4 animate-pulse" />
                  <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse" />
                  <div className="h-8 bg-gray-200 rounded w-1/3 animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
